import IconArrowDown from 'assets/Icons/Arrow/Icon_arrow_down';

import DropdownButton from 'components/Buttons/DropdownButton';
import SearchFilterDropdownNotPeriod from 'components/Dropdown/SearchFilterDropdownNotPeriod';
import SearchInput from 'components/Input/SearchInput';
import { consultationListPageText, diagnosisListPageText, mindUpAllReservationSearchFilterList } from 'constants/diagnosisListPageConstants';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { palette, zIndex } from 'styles/Global/globalStyles';
import { DropdownIconWrapper, ResetIconWrapper } from 'styles/Input/inputStyle';
import RefreshIcon from 'assets/Icons/Common/RefreshIcon';
import IconArrowUp from 'assets/Icons/Arrow/Icon_arrow_up';

import { isConsultationHospital } from 'utils/hospitalUtils';
import { useLoginStore } from 'store/useLoginDataStore';
import { MindUpAdminAllReservationConsultationFilterType } from 'models/MindUpAdmin/MindUpAdminAllReservationConsultationPageTypes';

const MindUpAdminAllReservationConsultationFilter = ({
    diagnosisNumber,
    selectedSearchFilter,
    handleDropdown,
    onSearchFilterDropdown,
    setOnSearchFilterDropdown,
    onChange,
    searchValue,
    handleSearchFilter,
}: MindUpAdminAllReservationConsultationFilterType) => {
    const searchFilterRef = useRef<HTMLButtonElement>(null);

    const { loginData } = useLoginStore();

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (searchFilterRef.current && !searchFilterRef.current.contains(event.target) && onSearchFilterDropdown) {
                setOnSearchFilterDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onSearchFilterDropdown]);

    return (
        <>
            {diagnosisNumber + (isConsultationHospital(loginData.hospitalId) ? consultationListPageText.countDiagnosis : diagnosisListPageText.countDiagnosis)}
            <FilterButtonWrapper>
                <DropdownButton ref={searchFilterRef} onClick={setOnSearchFilterDropdown}>
                    {mindUpAllReservationSearchFilterList[selectedSearchFilter]}
                    <DropdownIconWrapper>
                        {onSearchFilterDropdown ? (
                            <>
                                <IconArrowUp />
                                <SearchFilterDropdownNotPeriod selectedSearchFilter={selectedSearchFilter} handleDropdown={handleDropdown} type='mindUpAllReservation' />
                            </>
                        ) : (
                            <IconArrowDown />
                        )}
                    </DropdownIconWrapper>
                </DropdownButton>
                <SearchInputWrapper>
                    <SearchInput onChange={onChange} searchValue={searchValue} handleSearchFilter={handleSearchFilter} />
                </SearchInputWrapper>
                <ResetIconWrapper style={{ marginLeft: '-4px' }} onClick={() => window.location.reload()}>
                    <RefreshIcon />
                </ResetIconWrapper>
            </FilterButtonWrapper>
        </>
    );
};

export default MindUpAdminAllReservationConsultationFilter;

const FilterButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    gap: 6px;
`;

const SearchInputWrapper = styled.div`
    position: relative;
    width: 220px;
    height: 100%;
    border-radius: 4px;
`;
